import React from 'react'

export default props => {
        const { input, ...other } = props

        return (

            <input
                style={{
                    position: 'absolute',
                    zIndex: '-1',
                    top: '-100%',
                    left: '-100%',
                    display: 'block',
                    width: '1px',
                    visibility: 'hidden'
                }}
                ref={ref => input(ref)}
                type='file'
                {...other}
            />
        )

}



// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/HiddenInputFile/index.js